module.exports = __webpack_public_path__ + "static/media/ils_gold_purchase_failed.a88065d7.svg";